import React from "react";
import { Text, Select, Space } from "@mantine/core";
import { Controller, Control, FieldErrors } from "react-hook-form";
import { MantineProvider } from "@mantine/core";

interface SelectInputRefProps {
  name: string;
  data: any[]; // TODO: Define a stricter type if possible
  label: string;
  errors: FieldErrors<any>;
  control: Control<any>;
  required?: boolean;
  disabled?: boolean;
  subText?: string;
  errorMessage?: string;
  searchable?: boolean;
  clearable?: boolean;
  placeholder?: string;
  dataTestId?: string;
}

const SelectInputRef: React.FC<SelectInputRefProps> = ({
  name,
  data,
  label,
  errors,
  control,
  required = true,
  disabled = false,
  subText = "",
  searchable = false,
  clearable = false,
  errorMessage = "This field is required",
  placeholder = "",
  dataTestId = "select-input",
}) => {
  return (
    <MantineProvider>
      <Controller
        name={name}
        control={control}
        rules={{ required }}
        render={({ field }) => (
          <Select
            label={label}
            data={data}
            disabled={disabled}
            searchable={searchable}
            clearable={clearable}
            placeholder={placeholder}
            data-testid={dataTestId}
            {...field}
          />
        )}
      />
      {errors?.[name]?.type === "required" && (
        <Text size="sm" style={{ color: "red" }}>
          {errorMessage || "This field is required"}
        </Text>
      )}
      {subText && (
        <Text size="xs" fs="italic">
          {subText}
        </Text>
      )}
      <Space h="md" />
    </MantineProvider>
  );
};

export default SelectInputRef;
